module.exports = __webpack_public_path__ + "static/bg-d087eca4181eda4d70b00df19a3a04b1.jpg";